import { render } from "./LpnewView.vue?vue&type=template&id=20bbcc16"
import script from "./LpnewView.vue?vue&type=script&lang=js"
export * from "./LpnewView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__